/**
 * Crop workaround for iFrame on iOS 10+ (May 17 2018)
 *
 * The Width/Height of IFrame on iOS, whatever the values you set, will always have width/height
 * equal to width/height of the document, which gets rendered inside that iFrame. Furthermore,
 * the width/height of iFrame is calculated regarding the entire render tree, not its visible parts.
 *
 * This behavior brings tons of bugs and issues. One of those issues is solved by this workaround.
 *
 * As was said before, iOS automatically expands the iFrame height in order to make it equal to
 * content document height, and its not possible to make it smaller than the height of the document.
 *
 * Unfortunately, this iOS behavior is not responsive. It means, that any dynamic changes made with
 * document (eg. overall change of font-size) will not force frame height recalculation, but the
 * document will change its height. Because of that, we start facing an issue, when some part of the
 * document content is cropped.
 *
 * This visual issue can be solved by manual recalculation of the iFrame height, since it still
 * possible to set the size of iframe larger than the size of document.
 */

import bowser from 'yola-bowser';

function connect(frame, refreshTime = 1000) {
  if (!bowser.ios) {
    return;
  }

  const iosContentWrapper = frame.contentDocument.querySelector('.ios-elastic-width-workaround');

  let previousHeightValue;

  function recalcFrameSize() {
    const { height } = iosContentWrapper.getBoundingClientRect();

    if (previousHeightValue !== height) {
      previousHeightValue = height;

      requestAnimationFrame(() => {
        // eslint-disable-next-line no-param-reassign
        frame.style.height = `${height}px`;
      });
    }
  }

  recalcFrameSize();

  const intervalId = setInterval(recalcFrameSize, refreshTime);

  frame.contentWindow.addEventListener('orientationchange', recalcFrameSize);

  frame.contentWindow.addEventListener('unload', () => {
    clearInterval(intervalId);
  });
}

export default {
  connect,
};
